import Button from '@/components/ui/button/button.component';
import { cn } from '@/lib/utils';
import { topBarTranslations } from '../topbar.messages';

import CaretDown from '@/assets/icons/caret-down.svg?react';
import { T } from '@/components/i18n/message.i18n.component';
import { StepIconTopbar } from '../step-icon.topbar/step-icon.topbar.component';
import { TopbarProps } from '../topbar.component';

export const PretailorTopbar = ({
  className,
  loading,
  onNext: handleNext,
  onToProducts: handleOnToProducts,
  ...props
}: TopbarProps) => {
  return (
    <div
      className={cn(
        'w-full h-15 px-19 flex flex-row justify-between bg-white',
        'border border-b border-other-stroke',
        className,
      )}
      {...props}
    >
      <div className="h-full flex">
        <Button
          data-testid="pre-tailoring-topbar-button-back-to-products"
          onClick={handleOnToProducts}
          variant="topbar"
          size="topbar-wide"
        >
          <CaretDown className="mr-2 rotate-90" />
          <T {...topBarTranslations.backToProducts} />
        </Button>
        <Button
          data-testid="pre-tailoring-topbar-button-step-1"
          index={1}
          variant="topbar"
          size="topbar-wide"
          className="ml-[1px] border-l-0"
        >
          <StepIconTopbar data-testid="pre-tailoring-topbar-icon-step-1" index={1} state="active" />
          <T {...topBarTranslations.pretailoringButton} />
        </Button>
        <Button
          data-testid="pre-tailoring-topbar-button-step-2"
          index={2}
          variant="topbar"
          disabled
          size="topbar-wide"
          className="ml-[1px] border-l-0"
        >
          <StepIconTopbar data-testid="pre-tailoring-topbar-icon-step-2" index={2} state="disabled" />
          <T {...topBarTranslations.tailoringButton} />
        </Button>
      </div>
      <div className="h-full flex gap-[1px]">
        <Button
          data-testid="pre-tailoring-topbar-button-next"
          type="submit"
          form="hook-form"
          disabled={loading}
          onClick={handleNext}
          variant="topbar"
          className="font-medium"
        >
          <T {...topBarTranslations.saveButton} />
          <CaretDown className="ml-2 -rotate-90" />
        </Button>
      </div>
    </div>
  );
};
